import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useFeaturesStore = defineStore('features', () => {
  const enabledFeatures = ref<string[]>([]);

  function setEnabledFeatures(features: string[]) {
    enabledFeatures.value = features;
  }

  return {
    // state
    enabledFeatures,

    // getters

    // actions
    setEnabledFeatures,
  };
});
